/**
* Initializes the site's ourAwardees component.
* @constructor
* @param {Object} el - The site's ourAwardees container element.
*/
import Choices from 'Choices.js'
const ourAwardees = el => {
	// const toggle = el.querySelector('.awardees__sort-options')
	// const filters = el.querySelector('.awardees__filters')
	
	const locationFilter = new Choices('#location-filter', {
		searchEnabled: false,
		searchChoices: false,
		position: 'bottom',
		shouldSort: false,
		shouldSortItems: false,
		itemSelectText: ''
	})

	const typeFilter = new Choices('#type-filter', {
		searchEnabled: false,
		searchChoices: false,
		position: 'bottom',
		shouldSort: false,
		shouldSortItems: false,
		itemSelectText: ''
	})

	const fundingFilter = new Choices('#funding-rnd-filter', {
		searchEnabled: false,
		searchChoices: false,
		position: 'bottom',
		shouldSort: false,
		shouldSortItems: false,
		itemSelectText: ''
	})

	const sortOrder = new Choices('#sort-order', {
		searchEnabled: false,
		searchChoices: false,
		position: 'bottom',
		shouldSort: false,
		shouldSortItems: false,
		itemSelectText: ''
	})

	// toggle.addEventListener('click', () => {
	// 	filters.classList.toggle('hidden')
	// })

	// window.addEventListener('resize', () => {
	// 	filters.classList.add('hidden')
	// })
}
export default function(el) {
    ourAwardees(el)
}
